// 构造边对象，初始化
export class Edge {
  constructor(first, second, value) {
    this._first = first;
    this._second = second;
    this._value = value;
  }
  //得到第一个节点
  getFirst() {
    return this._first;
  }
  // 得到第二个节点
  getSecond() {
    return this._second;
  }
  // 得到value值
  getValue() {
    return this._value;
  }
}
